@if (prescriptions?.length) {
  <div class="prescriptions-container">
    @if (hasAnyPrescriptionSent) {
      <h4>{{ 'download_files_prescriptions_title' | locale }}</h4>
      <mat-divider></mat-divider>
    }

    @for (prescription of prescriptions; track prescription) {
      <div class="prescriptions-container">
        @if (prescription.status === prescriptionStatus.SENT || prescription.status === prescriptionStatus.SENT_UNVALIDATED) {
          <app-select-item
            [itemText]="prescription.medicines[0].active"
            itemSubtext=""
            color="var(--custom-button-color, #C3FF00)"
            iconName="pill"
            [south]="true"
            (click)="getUrl(prescription.fileS3Key)"
          >
          </app-select-item>
          <!-- duplicates -->
          @if (prescription.sendDuplicate) {
            <app-select-item
              [itemText]="prescription.medicines[0].active + ' - ' + ('download_files_duplicate' | locale)"
              itemSubtext=""
              color="var(--custom-button-color, #C3FF00)"
              iconName="pill"
              [south]="true"
              (click)="getUrl(prescription.fileDuplicateS3Key)"
            >
            </app-select-item>
          }
        }
      </div>
    }

    @for (instruction of instructions; track instruction) {
      <app-select-item
        [itemText]="'download_files_instructions' | locale"
        itemSubtext=""
        color="var(--custom-button-color, #C3FF00)"
        iconName="pill"
        [south]="true"
        (click)="getUrl(instruction)"
      >
      </app-select-item>
    }
  </div>
  <br />
}

@if (medicalOrders?.length) {
  <div class="medical-orders-container">
    <h4>{{ 'download_files_medical_orders_title' | locale }}</h4>
    <mat-divider></mat-divider>
    @for (medicalOrder of medicalOrders; track medicalOrder.id; let index = $index) {
      @if (medicalOrder.fileS3Key) {
        <app-select-item
          [itemText]="
            (medicalOrders?.length === 1 ? '' : index + 1 + ' - ') +
            (medicalOrder?.practices && medicalOrder.practices!.length > 0
              ? medicalOrder.practices![0].name + (medicalOrder.practices!.length > 1 ? ' (+)' : '')
              : medicalOrder.description)
          "
          itemSubtext=""
          color="#29293B"
          iconName="prescription-green"
          [south]="true"
          (click)="getUrl(medicalOrder.fileS3Key)"
        >
        </app-select-item>
      }
      @if (medicalOrder.instructionsS3Key) {
        <app-select-item
          [itemText]="(medicalOrders?.length === 1 ? '' : index + 1 + ' - ') + ('diagnosis_prescription_indications' | locale)"
          itemSubtext=""
          color="#29293B"
          iconName="prescription-green"
          [south]="true"
          (click)="getUrl(medicalOrder.instructionsS3Key)"
        >
        </app-select-item>
      }
    }
  </div>
  <br />
}

@if (medicalCareRecord) {
  <div class="medical-care-record-container">
    <h4>{{ 'download_files_medical_care_records_title' | locale }}</h4>
    <mat-divider></mat-divider>
    <app-select-item
      [itemText]="'download_files_medical_care_records' | locale"
      itemSubtext=""
      color="#FF4D7C"
      iconName="medicine"
      [south]="true"
      (click)="getUrl(medicalCareRecord.fileS3Key)"
    >
    </app-select-item>
  </div>
}
